import {api} from './api'


export const searchApi = api.injectEndpoints({
  endpoints: (build) => ({
    search: build.query<any, any>({
      query: (params) => {
        return {
          url: '/search',
          method: 'GET',
          params: params
        }
      }
    })
  })
})

export const { useSearchQuery } = searchApi
